<template>
  <div>
    <div class="config">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-body">
              <h6 class="card-subtitle mb-2 text-muted">
                Unit options
              </h6>
              <ul class="actions">
                <li><a href="" v-on:click.prevent="setMetric">Set to metric</a></li>
                <li><a href="" v-on:click.prevent="setUS">Set to US</a></li>
                <li><a href="" v-on:click.prevent="setImperial">Set to Imperial</a></li>
              </ul>
              <div class="row">
                <div class="col">
                  <h6>Hops</h6>
                  <div class="form-check" v-for="(unit, index) in massUnits">
                    <input class="form-check-input"
                           type="radio"
                           name="hop-unit"
                           :id="'hop-units-' + index"
                           v-on:change="handleChange"
                           :value="unit.unit"
                           :checked="unit.unit === hopUnit">
                    <label class="form-check-label" :for="'hop-units-' + index">
                      {{unit.name}}
                    </label>
                  </div>
                </div>

                <div class="col">
                  <h6>Mass</h6>
                  <div class="form-check" v-for="(unit, index) in massUnits">
                    <input class="form-check-input"
                           type="radio"
                           name="mass-unit"
                           :id="'mass-units-' + index"
                           v-on:change="handleChange"
                           :value="unit.unit"
                           :checked="unit.unit === massUnit">
                    <label class="form-check-label" :for="'mass-units-' + index">
                      {{unit.name}}
                    </label>
                  </div>
                </div>

                <div class="col">
                  <h6>Volume</h6>
                  <div class="form-check" v-for="(unit, index) in volumeUnits">
                    <input class="form-check-input"
                           type="radio"
                           name="volume-unit"
                           :id="'volume-units-' + index"
                           v-on:change="handleChange"
                           :value="unit.unit"
                           :checked="unit.unit === volumeUnit">
                    <label class="form-check-label" :for="'volume-units-' + index">
                      {{unit.name}}
                    </label>
                  </div>
                </div>

                <div class="col">
                  <h6>Temperature</h6>
                  <div class="form-check" v-for="(unit, index) in tempUnits">
                    <input class="form-check-input"
                           type="radio"
                           name="temperature-unit"
                           :id="'temperature-units-' + index"
                           v-on:change="handleChange"
                           :value="unit.unit"
                           :checked="unit.unit === tempUnit">
                    <label class="form-check-label" :for="'temperature-units-' + index">
                      {{unit.name}}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>


<script>
  import { EventBus } from '../lib/event-bus.js';

  export default {
    data() {
      return {
        massUnit: null,
        volumeUnit: null,
        tempUnit: null,
        hopUnit: null,

        massUnits: [
          { unit: 'g',  name: 'Gram' },
          { unit: 'kg', name: 'Kilogram' },
          { unit: 'oz', name: 'Ounce' },
          { unit: 'lb', name: 'Pound' },
        ],
        volumeUnits: [
          { unit: 'ml',       name: 'Millilitre' },
          { unit: 'l',        name: 'Litre' },
          { unit: 'US gal',   name: 'US Gallon' },
          { unit: 'US pint',  name: 'US Pint' },
          { unit: 'Imp pint', name: 'Imperial Pint' },
          { unit: 'Imp gal',  name: 'Imperial Gallon' }
        ],
        tempUnits: [
          { unit: '°F', name: 'Fahrenheit' },
          { unit: '°C', name: 'Celsius' }
        ]
      }
    },
    methods: {
      setDefaults() {
        if (!localStorage.hopUnit)    { localStorage.hopUnit    = "g" }
        if (!localStorage.massUnit)   { localStorage.massUnit   = "kg" }
        if (!localStorage.volumeUnit) { localStorage.volumeUnit = "l" }
        if (!localStorage.tempUnit)   { localStorage.tempUnit   = "°C" }

        this.setUnit({ property: "hopUnit",    value: localStorage.hopUnit });
        this.setUnit({ property: "massUnit",   value: localStorage.massUnit });
        this.setUnit({ property: "volumeUnit", value: localStorage.volumeUnit });
        this.setUnit({ property: "tempUnit",   value: localStorage.tempUnit });
      },

      setMetric() {
        this.setUnit({ property: "hopUnit",    value: "g" });
        this.setUnit({ property: "massUnit",   value: "kg" });
        this.setUnit({ property: "volumeUnit", value:  "l" });
        this.setUnit({ property: "tempUnit",   value: "°C" });
      },

      setUS() {
        this.setUnit({ property: "hopUnit",    value: "oz" });
        this.setUnit({ property: "massUnit",   value: "lb" });
        this.setUnit({ property: "volumeUnit", value:  "US gal" });
        this.setUnit({ property: "tempUnit",   value: "°F" });
      },

      setImperial() {
        this.setUnit({ property: "hopUnit",    value: "oz" });
        this.setUnit({ property: "massUnit",   value: "lb" });
        this.setUnit({ property: "volumeUnit", value:  "Imp gal" });
        this.setUnit({ property: "tempUnit",   value: "°F" });
      },

      handleChange(e) {
        let unitNode = e.currentTarget;
        switch(unitNode.getAttribute('name')) {
          case 'hop-unit':
            this.hopUnit = unitNode.value;
            localStorage.hopUnit = unitNode.value;
            EventBus.$emit('hopUnitChanged', unitNode.value);
            break;

          case 'mass-unit':
            this.massUnit = unitNode.value;
            localStorage.massUnit = unitNode.value;
            EventBus.$emit('massUnitChanged', unitNode.value);
            break;

          case 'volume-unit':
            this.volumeUnit = unitNode.value;
            localStorage.volumeUnit = unitNode.value;
            EventBus.$emit('volumeUnitChanged', unitNode.value);
            break;

          case 'temperature-unit':
            this.tempUnit = unitNode.value;
            localStorage.tempUnit = unitNode.value;
            EventBus.$emit('volumeUnitChanged', unitNode.value);
            break;
        }
      },
      setUnit(unit) {
        this[unit.property] = unit.value;
        localStorage[unit.property]  = unit.value;
        EventBus.$emit(unit.property + 'Changed', unit.value);
      }
    },
    beforeMount() {
      this.setDefaults();
    }
  }
</script>

<style scoped lang="scss">
  .config {
    padding: 1em 0;
    font-size: .8em;

    .card-subtitle {

    }
    .actions {
      list-style-type: none;
      padding: 0;
      margin: 1em 0 0 0;

      li {
        display: inline-block;

        &:before {
          content: "|";
          margin: 0 1em;
        }
        &:first-child:before { display: none; }
      }
    }
  }
</style>
